import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="py-12 px-6 overflow-auto">
      <div className="max-w-4xl mx-auto rounded-lg p-8 text-white mb-8 privacy-content">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        <p className="text-sm mb-4">Effective Date: April 19, 2025</p>
        
        <section className="mb-4">
          <h2 className="text-xl font-bold mb-2">1. Introduction</h2>
          <p>Welcome to Quotes, a mobile application developed by Kanto Projects. This privacy policy outlines how we collect, use, and protect your personal information when you use our application on iOS. By downloading, installing, or using Quotes, you agree to the terms outlined in this privacy policy.</p>
        </section>
        
        <section className="mb-4">
          <h2 className="text-xl font-bold mb-2">2. Information We Collect</h2>
          <p>We collect the following personal information:</p>
          <ul className="list-disc pl-6">
            <li>Name: Used to personalize your app experience and quotes</li>
            <li>Email Address: Used for account verification, communication, and account recovery</li>
            <li>Authentication Data: When you sign in using Google Sign-In, Apple Sign-In, or email</li>
          </ul>
          
          <p className="mt-2">Device Information:</p>
          <ul className="list-disc pl-6">
            <li>iOS version</li>
            <li>Device model</li>
            <li>App version</li>
            <li>Basic usage statistics</li>
          </ul>
          
          <p className="mt-2">User Content:</p>
          <ul className="list-disc pl-6">
            <li>Personal quotes created in the app</li>
            <li>Quote preferences and favorites</li>
            <li>Custom backgrounds uploaded by users</li>
          </ul>
          
          <p>Children's Privacy: We do not knowingly collect personal information from children under 13 years of age. If we discover that a child under 13 has provided us with personal information, we will promptly delete it.</p>
        </section>
        
        <section className="mb-4">
          <h2 className="text-xl font-bold mb-2">3. How We Use Your Information</h2>
          <p>Your personal information is used for:</p>
          <ul className="list-disc pl-6">
            <li>Account Management: Identity verification and personalized experience</li>
            <li>Service Improvement: Analytics to enhance app functionality and user experience</li>
            <li>Quote Personalization: To personalize quotes with your name when requested</li>
            <li>Preferences Storage: To remember your quote display and customization preferences</li>
            <li>Communications: Updates about the app and response to user inquiries</li>
            <li>Marketing: Promotional materials about app features (with opt-out option)</li>
          </ul>
        </section>
        
        <section className="mb-4">
          <h2 className="text-xl font-bold mb-2">4. Third-Party Services</h2>
          <p>We utilize the following services:</p>
          <ul className="list-disc pl-6">
            <li>Google Firebase: Authentication, data storage, and analytics</li>
            <li>Google AdMob: Advertisement delivery</li>
            <li>Google Sign-In: Authentication</li>
            <li>Apple Sign-In: Authentication</li>
            <li>WidgetKit: For iOS home screen widget functionality</li>
          </ul>
          <p>These services may collect and process data according to their own privacy policies.</p>
        </section>
        
        <section className="mb-4">
          <h2 className="text-xl font-bold mb-2">5. Data Storage and Security</h2>
          <ul className="list-disc pl-6">
            <li>Data is securely stored on Google Firebase servers</li>
            <li>Industry-standard encryption and security measures are implemented</li>
            <li>Regular security audits and updates are performed</li>
            <li>Widget data is stored locally on your device using App Groups</li>
          </ul>
        </section>
        
        <section className="mb-4">
          <h2 className="text-xl font-bold mb-2">6. User Rights</h2>
          <p>You can:</p>
          <ul className="list-disc pl-6">
            <li>Access your personal data</li>
            <li>Request corrections to your information</li>
            <li>Delete your account and associated data</li>
            <li>Delete specific personal quotes you've created</li>
            <li>Opt-out of marketing communications</li>
          </ul>
          <p>Exercise these rights through the app's settings or by contacting us</p>
        </section>
        
        <section className="mb-4">
          <h2 className="text-xl font-bold mb-2">7. iOS-Specific Privacy Features</h2>
          <ul className="list-disc pl-6">
            <li>Compliance with App Tracking Transparency</li>
            <li>Support for iOS privacy features like App Privacy Report</li>
            <li>Local storage of widget configuration data</li>
            <li>Implementation of Apple's privacy best practices</li>
            <li>Optional notifications with user permission</li>
          </ul>
        </section>
        
        <section className="mb-4">
          <h2 className="text-xl font-bold mb-2">8. Data Collection Opt-Out</h2>
          <ul className="list-disc pl-6">
            <li>Use App Tracking Transparency controls on your iOS device</li>
            <li>Adjust privacy settings in app preferences</li>
            <li>Delete specific quotes or content</li>
            <li>Delete your account and all associated data within the app</li>
          </ul>
        </section>
        
        <section className="mb-4">
          <h2 className="text-xl font-bold mb-2">9. Compliance</h2>
          <p>We comply with:</p>
          <ul className="list-disc pl-6">
            <li>General Data Protection Regulation (GDPR)</li>
            <li>California Consumer Privacy Act (CCPA)</li>
            <li>Apple App Store privacy guidelines</li>
          </ul>
        </section>
        
        <section className="mb-4">
          <h2 className="text-xl font-bold mb-2">10. Changes to This Policy</h2>
          <p>We may update this policy to reflect:</p>
          <ul className="list-disc pl-6">
            <li>Changes in our practices</li>
            <li>New features or services</li>
            <li>Legal or regulatory requirements</li>
          </ul>
          
          <p>Users will be notified of significant changes via:</p>
          <ul className="list-disc pl-6">
            <li>Email notification</li>
            <li>In-app notification</li>
            <li>App store update notes</li>
          </ul>
        </section>
        
        <section className="mb-4">
          <h2 className="text-xl font-bold mb-2">11. Contact Information</h2>
          <p>For privacy-related inquiries:</p>
          <ul className="list-disc pl-6">
            <li>Email: apps@kantoprojects.com</li>
            <li>Website: www.kantoprojects.com</li>
          </ul>
        </section>
        
        <p className="text-sm mt-4">This policy was last updated on April 19, 2025</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 